/**
 * Regista o service worker mínimo (public/sw.js) que torna a app instalável.
 * Só regista em produção e quando o browser suporta service workers.
 * O registo acontece no evento `load` da window para não competir com o boot.
 *
 * @param opts.enabled — força o ramo (default: import.meta.env.PROD). Usado nos testes.
 */
export function registerServiceWorker(opts?: { enabled?: boolean }): void {
  const enabled = opts?.enabled ?? import.meta.env.PROD;
  if (!enabled) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Falhar o registo do SW nunca pode partir a app. Em produção fica
      // silencioso; em dev/preview avisa para diagnosticar MIME/scope/HTTPS.
      if (import.meta.env.DEV) console.warn('[SW] registo falhou:', err);
    });
  });
}
